import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { axiosGet } from './axios.helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;

export const login = async (email, password) => {
  await axios
    .post(`${baseUrl}/login`, {
      data: {
        attributes: {
          email,
          password,
        },
      },
    })
    .then(({ data }) => {
      const { access_token: accessToken } = data;

      console.log('== USER LOGGED IN ==');
      localStorage.setItem('token', accessToken);
    });
};

export const getMe = async () => axiosGet('/me');
